import styled from "@emotion/styled";
import { Body, Title } from ".";
import { Spacer } from "components/general/Spacer/Spacer";
import { SadBopStatic } from "components/general/SadBopStatic";
import { Text } from "components/general/Text";
import { css } from "@emotion/react";
import { useToggleIntercom } from "hooks/useToggleIntercom";
import { GlobalStore } from "../../../store/global/GlobalStore";

// Shown when fetching trade history is not successful
export const ErrorDisplay = () => {
  const { showIntercom } = useToggleIntercom();
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <Wrapper>
      <Container>
        <SadBopStatic />
        <Spacer height="22px" />
        <Title>Something went wrong</Title>
        <Body>
          Please try again. If the problem persists you can{" "}
          <Text
            as={"span"}
            textStyle={"Paragraph"}
            size={"Large"}
            color={theme.font.primary.default}
            textCss={css`
              cursor: pointer;
              text-decoration: underline;
            `}
            onClick={() => showIntercom()}
          >
            contact us.
          </Text>
        </Body>
      </Container>
    </Wrapper>
  );
};

// Sub-components

const Wrapper = styled.div`
  width: 100%;
  margin: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
  margin: auto;
`;
